import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import useOffersToCompareSlice from 'app/store/offersToCompareSlice';
import { useAuth0 } from '@auth0/auth0-react';
import useAuthUser from '../../hooks/useAuthUser';
import { userSignOut } from '../../api/UserApi';
import { ILocalStoreKey } from '../../types';

function SignOutPage() {
  const user = useAuthUser();
  const { logout } = useAuth0();

  useEffect(() => {
    async function fetchData() {
      if (user?.logout) {
        await userSignOut();
      }
      useOffersToCompareSlice.persist.clearStorage();

      // Clear all form-related localStorage to prevent stale data
      // affecting future logins (e.g., Processor users seeing Merchant onboarding)
      localStorage.removeItem(ILocalStoreKey.merchantFormData);
      localStorage.removeItem(ILocalStoreKey.processorData);
      localStorage.removeItem(ILocalStoreKey.loginQueryParamsData);

      setTimeout(() => {
        logout({
          logoutParams: {
            returnTo: import.meta.env.PUBLIC_URL,
          },
        });
      }, 1000);
    }
    fetchData();
  }, [logout, user]);

  return (
    <div className="flex flex-col flex-auto items-center sm:justify-center min-w-0">
      <Paper className="flex items-center w-full sm:w-auto min-h-full sm:min-h-auto rounded-0 py-32 px-16 sm:p-48 sm:rounded-2xl sm:shadow">
        <div className="w-full max-w-320 sm:w-320 mx-auto sm:mx-0">
          <img className="w-48 mx-auto" src="assets/images/logo/logo.svg" alt="logo" />

          <Typography className="mt-32 text-4xl font-extrabold tracking-tight leading-tight text-center">
            You have signed out!
          </Typography>
        </div>
      </Paper>
    </div>
  );
}

export default SignOutPage;
